import { Link, useLocation } from "react-router-dom";
import { LOGO_URL, FACEBOOK_URL, ORDER_ONLINE_URL } from "../lib/data";

export default function Footer() {
    const { pathname } = useLocation();
    const isHome = pathname === "/";

    // Mobile sub-pages → dark footer; everywhere else → light footer.
    const dark = !isHome;

    return (
        <footer
            data-testid="site-footer"
            className={`relative border-t transition-colors duration-300 ${
                dark
                    ? "bg-[#FAF8F4] md:bg-[#FAF8F4] border-black/10"
                    : "bg-[#FAF8F4] border-black/10"
            } ${dark ? "max-md:bg-[#0B0A09] max-md:border-white/10" : ""}`}
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-10 md:py-14 flex flex-col md:flex-row items-center justify-between gap-6">
                <img
                    src={LOGO_URL}
                    alt="The Gaffer Burgers & Shakes"
                    style={{ mixBlendMode: dark ? "normal" : "multiply" }}
                    className={`h-20 md:h-24 w-auto object-contain ${
                        dark ? "max-md:invert max-md:brightness-200" : ""
                    }`}
                />
                <nav className="flex items-center gap-6 md:gap-8 flex-wrap justify-center">
                    {[
                        {
                            href: ORDER_ONLINE_URL,
                            label: "Order",
                            testId: "footer-order-link",
                            external: true,
                        },
                        {
                            to: "/menu",
                            label: "Menu",
                            testId: "footer-menu-link",
                        },
                        {
                            to: "/book",
                            label: "Book",
                            testId: "footer-book-link",
                        },
                        {
                            to: "/vouchers",
                            label: "Vouchers",
                            testId: "footer-vouchers-link",
                        },
                        {
                            to: "/about",
                            label: "About",
                            testId: "footer-about-link",
                        },
                        {
                            href: FACEBOOK_URL,
                            label: "Facebook",
                            testId: "footer-facebook-link",
                            external: true,
                        },
                        {
                            to: "/admin",
                            label: "Owner",
                            testId: "footer-admin-link",
                        },
                    ].map((l) => {
                        const cls = `uppercase tracking-[0.18em] text-[0.72rem] font-extrabold no-underline transition-colors duration-300 ${
                            dark
                                ? "text-[#121212] hover:text-[#EB4A18] max-md:text-[#FAF8F4] max-md:hover:text-[#EB4A18]"
                                : "text-[#121212] hover:text-[#EB4A18]"
                        }`;
                        if (l.to) {
                            return (
                                <Link
                                    key={l.label}
                                    to={l.to}
                                    data-testid={l.testId}
                                    className={cls}
                                >
                                    {l.label}
                                </Link>
                            );
                        }
                        return (
                            <a
                                key={l.label}
                                href={l.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={l.testId}
                                className={cls}
                            >
                                {l.label}
                            </a>
                        );
                    })}
                </nav>
                <span
                    className={`text-xs uppercase tracking-[0.22em] text-center ${
                        dark
                            ? "text-[#6B6B6B] max-md:text-[#A39F98]"
                            : "text-[#6B6B6B]"
                    }`}
                >
                    © {new Date().getFullYear()} The Gaffer · Albany WA
                </span>
            </div>

            {/* Designer credit — small, muted, very bottom */}
            <div
                className={`border-t ${
                    dark
                        ? "border-black/5 max-md:border-white/5"
                        : "border-black/5"
                }`}
            >
                <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-4 flex justify-center">
                    <a
                        href="https://layerly.com.au"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-layerly-credit"
                        className={`text-[0.65rem] tracking-[0.22em] uppercase font-medium transition-colors duration-300 ${
                            dark
                                ? "text-[#9A958C] hover:text-[#121212] max-md:text-[#6B655B] max-md:hover:text-[#FAF8F4]"
                                : "text-[#9A958C] hover:text-[#121212]"
                        }`}
                    >
                        Made by Layerly
                    </a>
                </div>
            </div>
        </footer>
    );
}
